<template>
  <div class="pay-middle-page"></div>
</template>

<script>
export default {
  data() {
    return {};
  },
  beforeRouteEnter(to) {
    const { name, oId, str } = to.query;
    const query = { ...JSON.parse(str) };
    window.$router.replace({
      name,
      query,
      params: {
        oId,
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>
